import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  FETCH_CONTENT,
  RESET_CART,
} from "../actions/actionTypes";
import { productsTable } from "../firebase/content";

const initState = {
  content: {},
  products: {},
  images: [],
  items: [],
  quantity: 0,
};

const cartReducer = (state = initState, action) => {
  //INSIDE PRODUCT COMPONENT
  if (action.type === FETCH_CONTENT) {
    // console.log('action.content', action.content)
    let products = {};
    // console.log('action.content[productsTable]',action)
    if (action.content)
      action.content[productsTable].forEach((category) => {
        category.products.forEach((product) => {
          products[product.id] = { ...product, category };
        });
      });
    // console.log('products', products)
    // console.log('action.images', action.images)
    return {
      ...state,
      ...(action.content
        ? {
            content: action.content,
            products: products,
          }
        : {}),
      ...(action.images
        ? {
            images: action.images,
          }
        : {}),
    };
  } else if (action.type === ADD_TO_CART) {
    let existing = state.items.find(
      (item) => item.product === action.product && item.item === action.item
    );
    if (existing) {
      existing.quantity += 1;
    } else {
      state.items.push({
        product: action.product,
        item: action.item,
        quantity: 1,
      });
    }
    return {
      ...state,
      items: [...state.items],
      quantity: state.quantity + 1,
    };
  } else if (action.type === REMOVE_ITEM) {
    return {
      ...state,
      items: state.items.filter(
        (item) => item.product !== action.product || item.item !== action.item
      ),
      quantity: state.items
        .filter(
          (item) => item.product === action.product && item.item === action.item
        )
        .reduce((quantity, item) => quantity - item.quantity, state.quantity),
    };
  }
  //Inside cart component
  else if (action.type === ADD_QUANTITY) {
    let existing = state.items.find(
      (item) => item.product === action.product && item.item === action.item
    );
    if (existing) {
      existing.quantity += 1;
      return {
        ...state,
        items: [...state.items],
        quantity: state.quantity + 1,
      };
    }
  } else if (action.type === SUB_QUANTITY) {
    let existingIndex = state.items.findIndex(
      (item) => item.product === action.product && item.item === action.item
    );
    if (existingIndex >= 0) {
      let existing = state.items[existingIndex];
      if (existing.quantity > 0) {
        existing.quantity -= 1;
        return {
          ...state,
          items: [...state.items],
          quantity: state.quantity - 1,
        };
      }
    }
  } else if (action.type === RESET_CART) {
    return {
      ...state,
      items: [],
      quantity: 0,
    };
  }
  return state;
};

export default cartReducer;
